import { ICreatorTheme } from "../../../../../../../features/Common/modules/Theme/theme.interface";
import { getColorsFromCreatorTheme } from "../../../../../../../features/Common/modules/Theme/utils/Theme.utils";
import { getStylesObjFromCss } from "../../../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    container: {
      width: "100%",
      backgroundColor: "#166CD1",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      gap: "4px",
      padding: "8px",
      cursor: "pointer",
      borderRadius: "4px",
      marginBottom: "8px",
    },
    upgradeText: {
      fontSize: "16px",
      fontWeight: "600",
    },
  },
  componentName: "UpgradeBtn",
});

export const getThemedStyles = ({ theme }: { theme: ICreatorTheme }) => {
  const colors = getColorsFromCreatorTheme(theme);
  return getStylesObjFromCss({
    styles: {
      container: {
        backgroundColor: colors.color1 || "#166CD1",
      },
    },
    componentName: "UpgradeBtn",
  });
};
